// import '@babel/polyfill';
import * as Turbo from '@hotwired/turbo';

import LessonCourseEnquiries from './lesson_course_enquiries';
import './pollyfills';
import './load_service_worker';
import './font_observer';
import './global';
import './async_modules';

import './contact';
import './carousel';
import './zendesk_suggestions';
import './center_locator';
import './cl_header_navigation';
import './dynamic_pages';
import './homepage';
import PrimaryNav from './primary-nav';
import FaqMultiple from './faq-multiple-category';
import TemporarilyUnavailable from './temporarily-unavailable';
import VenueSearchResultsLoader from './venue_search_results_loader';
import VenueSelector from './venue_selector';
import CookieSettings from './cookie_settings';
import Bmi from './questionnaire/bmi';
import CheckBoxes from './questionnaire/check_boxes';
import QuestionnaireContactFields from './questionnaire/contact_fields';
import Range from './questionnaire/range';
import RefundFormMembershipNumber from './refund_form/membership_number';
import RefundValue from './refund_form/refund_value';
import RefundBankInputs from './refund_form/bank_inputs';
import RefundDateInputs from './refund_form/date_inputs';
import BannerCarousel from './banner_carousel';
import CenterLocator from './center_locator_book_activity';
import SwimForm from './swim_form'
import lessonEnquiryForm from './lesson_enquiry_form';
import venueHireForm from './venue_hire_form';
import refugeeForm from './refugee_form';
import PhotoComp from './photo_comp';
import alerts from './alerts';
import replacementLessons from './replacement_lessons';
import lvMemberships from './lv_memberships';
import timetable from './timetable';
import timetableTracking from './event_tracking/timetable';
import membershipsTracking from './event_tracking/memberships';
import timetableCarousel from './timetable_carousel';
import VideoBarModal from './video_bar_modal';
import lvBirthdays from './lv_birthdays';
import newShare from './news_link_share';
import bmi from './bmi';
import selfRefDatePicker from './datepicker/self-referral';
import ZendeskTicketFormsDatePicker from './datepicker/zendesk-ticket-forms';
import libTimetable from './lib_table';
import timetableFilters from './timetable_filters';
import membershipFilters from './membership_filters';
import membershipDetailsModal from './membership_details_modal';
import supportedMembershipForm from './contact/lessons_courses/supported_membership_forms'
import PupilRefundForm from './pupil_refund_request';
import TextExpander from './text_expander';
import centreLocatorWithLocationFinder from './centre_locator_with_location_finder/_index';
import CloudflareTurnstile from './cloudflare_turnstile';
import ReciteMe from './recite_me';
import CLFooter from './cl_footer';
// import ReciteMeButton from './recite_me_button'; // Disabled //

(() => {
  // Drive stays off: Turbo handles only the links and forms that ask for it
  // by name, so ordinary navigation is left to the browser.
  Turbo.session.drive = false;
})();

(() => {
  PrimaryNav();
})();

(() => {
  FaqMultiple();
})();

(() => {
  LessonCourseEnquiries();
})();

(() => {
  supportedMembershipForm();
})();

(() => {
  TemporarilyUnavailable();
})();

(() => {
  VenueSearchResultsLoader();
})();

(() => {
  VenueSelector();
})();

(() => {
  CookieSettings();
})();

(() => {
  Bmi();
})();

(() => {
  CheckBoxes();
})();

(() => {
  CloudflareTurnstile();
})();

(() => {
  QuestionnaireContactFields();
})();

(() => {
  Range();
})();

(() => {
  RefundFormMembershipNumber();
})();

(() => {
  RefundValue();
})();

(() => {
  RefundBankInputs();
})();

(() => {
  RefundDateInputs();
})();

(() => {
  BannerCarousel();
})();

(() => {
  CenterLocator();
})();

(() => {
  SwimForm();
})();

(() => {
  lessonEnquiryForm();
})();

(() => {
  venueHireForm();
})();

(() => {
  refugeeForm();
})();

(() => {
  PhotoComp();
})();

(() => {
  alerts();
})();

(() => {
  replacementLessons();
})();

(() => {
  lvMemberships();
})();

(() => {
  timetable();
})();

(() => {
  timetableTracking();
})();

(() => {
  timetableCarousel();
})();

(() => {
  VideoBarModal();
})();

(() => {
  lvBirthdays();
})();

(() => {
  newShare();
})();

(() => {
  bmi();
})();

(() => {
  selfRefDatePicker();
})();

(() => {
  libTimetable();
})();

(() => {
  timetableFilters();
})();

(() => {
  membershipFilters();
})();

(() => {
  membershipDetailsModal();
})();

(() => {
  membershipsTracking();
})();

(() => {
  PupilRefundForm();
})();

(() => {
  TextExpander();
})();

(() => {
  centreLocatorWithLocationFinder();
})();

(() => {
  ReciteMe();
})();

// (() => {
//   ReciteMeButton();
// })();

(() => {
  ZendeskTicketFormsDatePicker();
})();

(() => {
  CLFooter();
})();


